/* eslint-disable no-unused-vars */
import React, { useEffect, useCallback } from 'react';
import { Button, Space, Tooltip } from 'antd';
import useListFilters from '../../hooks/useListFilters';
import ListPage from '../../components/core/ListPage';
import { useNavigate } from 'react-router-dom';
import { useRadiologistInvoiceList } from '../../hooks/radiologists/useRadiologistInvoiceList';
import { getMonthTitleFromMonthNumber } from '../../utils/date';
const BREAD_CRUMBS = [
  { label: 'Revenue', to: '/user/radiologistlist' },
  { label: 'List', to: '/user/radiologist-invoice-list' },
];

export const RadiologistInvoiceList = () => {
  const { data, getList } = useRadiologistInvoiceList();
  const {
    loading,
    search,
    tableParams,
    setLoading,
    setSearch,
    setTableParams,
  } = useListFilters();
  const navigate = useNavigate();

  // Table
  const handleView = (record) => {
    navigate(`/user/radiologist-invoice/view?id=${record?.invoiceId}`);
  };

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getList({
        search,
        page: tableParams.pagination?.current,
        limit: tableParams.pagination?.pageSize,
        sortOrder: tableParams?.sortOrder,
        sortBy: tableParams?.sortField,
      });
      setLoading(false);
      // Update table params
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: response.totalItems,
        },
      });
    } catch (error) {
      setLoading(false);
    }
  }, [
    tableParams.pagination?.current,
    tableParams.pagination?.pageSize,
    tableParams?.sortOrder,
    tableParams?.sortField,
    search,
  ]);

  const handleTableChange = (pagination, _, sorter) => {
    setTableParams({
      pagination,
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field,
    });
  };

  useEffect(() => {
    reload();
  }, [
    tableParams.pagination?.current,
    tableParams.pagination?.pageSize,
    tableParams?.sortOrder,
    tableParams?.sortField,
    search,
  ]);

  const columns = [
    {
      title: 'No.',
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Invoice No.',
      dataIndex: 'invoiceNo',
      sorter: true,
    },
    {
      title: 'Revenue Amount',
      dataIndex: 'amount',
    },
    {
      title: 'For Month',
      dataIndex: 'monthNumber',
      sorter: true,
      render: (_, { monthNumber }) => {
        return monthNumber >= 0
          ? getMonthTitleFromMonthNumber(monthNumber)
          : undefined;
      },
    },
    {
      title: 'For Year',
      dataIndex: 'yearNumber',
      sorter: true,
    },
    {
      title: 'Actions',
      dataIndex: '',
      render: (_, record) => {
        return (
          <Space size="middle">
            {record?.paymentId ? null : (
              <Tooltip title="View Revenue" placement="left">
                <Button
                  icon={<i className="fa fa-eye" />}
                  onClick={() => handleView(record)}
                ></Button>
              </Tooltip>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <ListPage
        title={'Your Revenues'}
        data={data?.items || []}
        columns={columns}
        loading={loading}
        pagination={tableParams.pagination}
        rowKey={(record) => record?.invoiceId}
        onRefresh={reload}
        onSearch={setSearch}
        onTableChange={handleTableChange}
        breadCrumbItems={BREAD_CRUMBS}
        hideAddAction
      />
    </>
  );
};
